import { inject, Injectable, signal } from '@angular/core';
import { Departures } from 'app/core/enums/common.enum';
import {
    CnNvCommissionEndpoints,
    PkOtCommissionEndpoints,
} from 'app/core/enums/endpoints';
import { CommissionBody } from 'app/core/interfaces/finances';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommissionService {
    private _apiService = inject(ApiService);
    public departure = signal<
        | Departures.CONCESSION
        | Departures.NOVELTIES
        | Departures.PARKING
        | Departures.OTHER
    >(null);

    getEndpoints(): any {
        const endps =
            this.departure() === Departures.CONCESSION ||
            this.departure() === Departures.NOVELTIES
                ? CnNvCommissionEndpoints
                : PkOtCommissionEndpoints;

        return endps;
    }

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    getAll(playdateId: number, departure: Departures): Observable<any> {
        // !important

        //  Implement the logic to build the parameters for the filters
        // const params = this._apiService.buildParams(['sales_rep_id', '']);

        return this._apiService.get(
            `${this.getEndpoints().getAll}/${playdateId}/${departure}`
        );
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this.getEndpoints().getOne, id);
    }

    create(data: any): Observable<any> {
        return this._apiService.post(this.getEndpoints().create, data);
    }

    /**
     * Id unrequired for now
     */
    update(data: string, id: number): Observable<any> {
        return this._apiService.update(this.getEndpoints().update, data);
    }

    updateRate(data: string, id: number): Observable<any> {
        return this._apiService.update(
            this.getEndpoints().updateRate,
            data,
            id
        );
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this.getEndpoints().delete, id);
    }

    deletePkOt(params: CommissionBody): Observable<any> {
        const _params = {
            playdate_id: params.playdateId,
            location_id: params.locationId,
            departure: params.departure,
        };
        return this._apiService.deleteWithQueryParams(
            this.getEndpoints().delete,
            _params
        );
    }

    deleteSalesRep(id: number): Observable<any> {
        return this._apiService.delete(this.getEndpoints().deleteSalesRep, id);
    }

    reset(
        playdateId: number,
        departure: Departures,
        locationId: number
    ): Observable<any> {
        return this._apiService.post(
            `${this.getEndpoints().reset}/${playdateId}/${departure}/${locationId}`,
            {}
        );
    }
}
